var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CardContent, Stack, Typography } from "@mui/material";
import { getLocalizedString } from "@nitra/nkmb-card-components/utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useIsMobileContext } from "../../contexts";
import { CardFooter, CardWithShadow } from "../components";
export var SmallTextCard = function (props) {
    var title = props.title, shortText = props.shortText, createdAt = props.createdAt, onClickSpecialAction = props.onClickSpecialAction, imageUrl = props.imageUrl, to = props.to;
    var _a = useState(1), scale = _a[0], setScale = _a[1];
    var PLACEHOLDER = "/images/placeholder288x140.png";
    var _b = useState("url(".concat(imageUrl, "), url(").concat(PLACEHOLDER, ")")), cleanImageUrl = _b[0], setCleanImageUrl = _b[1];
    var isMobile = useIsMobileContext();
    var i18n = useTranslation().i18n;
    var currentLang = i18n.language;
    useEffect(function () {
        setCleanImageUrl("url(".concat(imageUrl, "), url(").concat(PLACEHOLDER, ")"));
    }, [imageUrl]);
    return (_jsxs(CardWithShadow, __assign({ onMouseEnter: function () { return setScale(1.08); }, onMouseLeave: function () { return setScale(1); }, onClickSpecialAction: onClickSpecialAction, to: to, fixedWidth: 288, sx: {
            display: "flex",
            flexDirection: "column"
        } }, { children: [_jsx(Box, __assign({ sx: { height: 140, overflow: "hidden" } }, { children: _jsx(Box, { sx: {
                        height: 140,
                        width: 288,
                        transform: "scale(".concat(scale, ")"),
                        transition: "transform 1.5s",
                        backgroundImage: cleanImageUrl,
                    } }) })), _jsxs(Stack, __assign({ sx: { position: "relative", height: 220 }, justifyContent: "space-between" }, { children: [_jsxs(CardContent, __assign({ sx: { maxHeight: 164, overflow: "hidden" } }, { children: [_jsx(Typography, __assign({ gutterBottom: true, variant: isMobile ? "podnaslovS" : "podnaslovM", component: "div" }, { children: getLocalizedString(title, currentLang) })), shortText &&
                                _jsx(Typography, __assign({ gutterBottom: true, variant: isMobile ? "bodyL" : "bodyM", component: "div", sx: {
                                        textOverflow: "ellipsis",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 3,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                    } }, { children: getLocalizedString(shortText, currentLang) }))] })), _jsx(CardFooter, { brightText: false, createdAt: createdAt, shareUrl: to })] }))] })));
};
